import {Pressable, Text, StyleSheet, View} from "react-native";
import React, {useState} from "react";
import {transferTaskToDate} from "../function/functions";
import {useDispatch} from "react-redux";
import {useTheme} from "@react-navigation/native";
import {useTranslation} from "react-i18next";
import {FontAwesome} from "@expo/vector-icons";

export default function TransferTaskButton(props) {
    const {  title = 'Edit', navigation, id, from, to } = props;
    const theme = useTheme();
    const dispatch = useDispatch();
    const {t, i18n} = useTranslation();
    const [transfer, setTransfer] = useState(false);
    const styles = StyleSheet.create({
        buttonTransfer: {
            height: 32,
            width: 32,
            backgroundColor: theme.colors.scheme[3],
            marginHorizontal:2,
            borderWidth: 2,
            borderColor:theme.colors.scheme[6],
            padding: 8,
            borderRadius: 100,
            justifyContent:'center',
            alignItems:'center'
        },
        buttonTransferConfirm: {
            display: 'flex',
            flexDirection:'row',
            height: 32,
            backgroundColor: theme.colors.scheme[3],
            marginHorizontal:2,
            borderWidth: 2,
            borderColor:theme.colors.scheme[6],
            padding: 4,
            borderRadius: 100,
            justifyContent:'center',
            alignItems:'center',
            shadowColor: theme.colors.scheme[2],
            shadowOpacity: 0.75,
            shadowRadius:12
        },
        text: {
            color:theme.colors.scheme[2],
            fontFamily:'Roboto-Black',
            paddingHorizontal:2,
            lineHeight:13,
            fontSize: 12,
            fontWeight:'bold'
        },
        textIcon: {
            color:theme.colors.scheme[2],
            fontFamily:'Roboto-Regular',
            paddingHorizontal:2,
            lineHeight:15,
            fontSize: 11,
            fontWeight:'bold'
        },
        buttonBack: {
            width: 32,
            height: 32,
            backgroundColor: theme.colors.scheme[3],
            fontFamily: 'Roboto-Regular',
            marginHorizontal: 2,
            padding: 0,
            lineHeight: 32,
            borderWidth: 2,
            borderColor:theme.colors.scheme[6],
            borderRadius: 100,
            justifyContent: 'center',
            alignItems: 'center',
            shadowColor: theme.colors.scheme[2],
            shadowOpacity: 0.75,
            shadowRadius:12
        },
    });
    return (
        <View style={{position:'absolute', top:0, right:0}}>
            {!transfer ? <Pressable style={(({ pressed }) => [
                { opacity: pressed ? 0.5 : 1.0 }, styles.buttonTransfer
            ])} onPress={() => {
                setTransfer(true);
            }}>
                <Text style={{fontSize:10}}>👋</Text>
            </Pressable>
            :
            <View style={{display:'flex', flexDirection:'row', flexWrap:'nowrap', position: 'absolute', right:0, top:0, justifyContent:'flex-end'}}>
                <Pressable style={({pressed}) => [styles.buttonBack, {display: 'flex', opacity: pressed ? 0.5 : 1}]} onPress={() => setTransfer(false)}>
                    <FontAwesome style={{fontSize:18, color:theme.colors.scheme[2]}} name={'arrow-left'} />
                </Pressable>
                <Pressable style={(({ pressed }) => [
                { opacity: pressed ? 0.5 : 1.0 }, styles.buttonTransferConfirm
                ])} onPress={(pressed) => {
                    setTransfer(false);
                    transferTaskToDate(dispatch, id, from, to);
                }}>
                <Text style={[styles.textIcon]}>👋</Text>
                <Text style={[styles.text]}>{t('task.transfer')}</Text>
            </Pressable>
            </View>}
        </View>
    );
}